import { Component, Input, OnInit } from '@angular/core';

// pipes
import { OpenStringInjectionPipe } from '../../pipes/open-string-injection.pipe';

@Component({
  selector: 'open-flow-banner',
  templateUrl: './open-flow-banner.component.html',
  styleUrls: ['./open-flow-banner.component.scss']
})
export class OpenFlowBannerComponent implements OnInit {
  @Input() componentDetails: any;
  @Input() formData: any;

  ratingId = 'rich-rating-badge';

  constructor(
    private stringInjectionPipe: OpenStringInjectionPipe
  ) {}
  
  ngOnInit(): void {
    if (this?.componentDetails?.settings?.dataDetail?.content && this.formData?.data) {
      this.componentDetails.settings.dataDetail.content = this.stringInjectionPipe.transform(this.componentDetails.settings.dataDetail.content, this.formData.data);
    } 

    if (
      this?.componentDetails?.settings?.class?.length &&
      this?.componentDetails?.settings?.class?.includes('dark-overlay')
    ) {
      if (this.componentDetails.settings?.socialProof) {
        this.componentDetails.settings.socialProof.theme = 'dark';
      }
    }
  }
}